import Axios from 'axios';
import { ES_URL } from '../../../../../../config';

const EsTopClientsAbnormal = (SearchField, SearchValue, getElements, changeElements, startDate, endDate) => {

  const elements = getElements();
  const query = {
    'size': 0,
    '_source': {
      'excludes': []
    },
    'aggs': {
      'ASN': {
        'terms': {
          'field': 'SourceAddress',
          'size': 25
        }
      }
    },
    'query': {
      'bool': {
        'must': [
          {
            'match_all': {}
          },
          {
            'range': {
              '@timestamp': {
                'gte': startDate,
                'lte': endDate,
                'format': 'epoch_millis'
              }
            }
          },
          {
            'match_phrase': {
              [SearchField]: {
                'query': SearchValue
              }
            }
          },
          {
            'exists': {
              'field': 'Abnormalities'
            }
          }
        ]
      }
    }
  };


  Axios.post(`${ES_URL}/filebeat-*/_search`, query).then(resp => {
    const buckets = resp.data.aggregations.ASN.buckets;
    buckets.map(bucket => {
      elements.push(
        {
          data: { id: bucket.key, size: Math.log10(bucket.doc_count+1) * 10, abnormal: true, entityType: 'AnomalousIPSource' }
        }
      );
      elements.push(
        {
          data: { id: `${SearchValue}:${bucket.key}`, source: bucket.key, target: SearchValue, abnormal: true }
        }
      );
    });
    changeElements(elements);
  });


};

export default EsTopClientsAbnormal;
